import React, { Component } from 'react';
import Dashboard from '../../components/Dashboard/Dashboard';

class DashboardRoute extends Component {
  render() {
    return (
      <section className='container-section'>
        <Dashboard />
      </section>
    );
  }
}

export default DashboardRoute;
